import React, { useLayoutEffect } from "react";
import { BrookshireBrotherLogoWithTagline, GroupShortTermDisabilityBrochure } from "../../../../../assets";
import CoreGstdImage from "../../../../../assets/CorePlanImages/CoreGstdImage.avif";
import "./gstd.scss";
import BrochureRenderer from "../../../../shared/brochureRenderer/BrochureRenderer";

const GSTD: React.FC = (): JSX.Element => {
	useLayoutEffect(() => {
		window.scrollTo(0, 0);
	});
	return (
		<div className="gstd-main-container">
			<div className="main-landing-container">
				<div className="left-section">
					<h3 className="main-benefits-title">Group Short Term Disability Plan</h3>
					<div className="powered-by-logo-container">
						<span>Powered By</span>
						<img src={BrookshireBrotherLogoWithTagline} alt="" />
					</div>
					<div className="plan-description">
						<ul>
							<li>
								Plan for the unexpected, and don’t find yourself without income during a time that you
								are unable to work due to an injury or illness.
							</li>
							<li>
								Ensure that you are able to receive benefits while you recover and help yourself to
								reduce financial burdens and stress by electing disability coverage.
							</li>
						</ul>
					</div>
				</div>
				<div className="right-section">
					<img src={CoreGstdImage} alt="Core Gstd image" />
				</div>
			</div>
			<h3 className="sub-heading-title">Plan Brochure</h3>

			<div className="brochure-renderer-container" style={{ overflow: "hidden" }}>
				<BrochureRenderer brochure={GroupShortTermDisabilityBrochure} />
			</div>
		</div>
	);
};

export default GSTD;
